import React, {Component} from 'react';
import {t} from '@lingui/macro';
import {connect} from 'react-redux';
import {DownOutlined} from '@ant-design/icons';
import {Dropdown, Input, Skeleton, Tag, Row, Col} from 'antd';
import Cookies from 'universal-cookie';
import ModalCompanyNew from '../Modal/CompanyNew';
import {Styled} from './style';
// import { SessionTimeoutTimer } from '../../containers/App/SessionTimeoutTimer';
import CompanyActions from '../../redux/Company/actions';
import {getRootUrl} from "../../helpers/urlSync";

const { readCompanies } = CompanyActions;

class Logo extends Component {
    inputRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            filter: undefined,
            filteredCompanies: [],
        };
    }

    setCSCookie = subdomain => {
        const cookies = new Cookies();
        const options = {};
        const urlMode = process.env.REACT_APP_URL_MODE;
        const urlDomain = process.env.REACT_APP_URL_DOMAIN;
        const cookiePrefix = process.env.REACT_APP_COOKIE_PREFIX;

        options.path = '/';
        if (urlMode === 'subdomain')
            options.domain = `.${urlDomain}`;
        options.expires = new Date(Date.now() + (3600 * 24 * 7 * 1000)); // 7 days

        // Set cookies
        if (urlMode === 'single')
            cookies.set(`${cookiePrefix}cs`, subdomain, options);
    };

    getUrl = (subdomain, path = '/dashboard') => getRootUrl(subdomain) + path;

    goToUrl = (e, subdomain, path = '/dashboard') => {
        const urlMode = process.env.REACT_APP_URL_MODE;
        const targetUrl = this.getUrl(subdomain, path);

        if (urlMode === "single")
            this.setCSCookie(subdomain);

        if (!e.ctrlKey && !e.metaKey) {
            e.preventDefault();
            window.location.href = targetUrl;
        }
    };

    showModal = () => {
        this.setState({ modalVisible: true });
    };

    hideModal = (subdomain = null) => {
        this.setState({ modalVisible: false });

        // Redirect
        if (subdomain) {
            // const urlMode = process.env.REACT_APP_URL_MODE;
            const targetUrl = this.getUrl(subdomain, '/dashboard?start');

            // if (urlMode === "single")
            this.setCSCookie(subdomain);

            window.location.href = targetUrl;
        }
    };

    onMenuVisibleChange = visible => {
        const { readCompanies } = this.props;
        if (visible)
            readCompanies();
    };

    renderLogoContent = (hideText = false) => {
        const {
            subdomain,
        } = this.props;

        return (
            <div className="logo-container">
                <div className="logo">
                    <img src="/assets/img/logo/logo-only-dark.png" alt="" />
                </div>
                <div className={`text${hideText ? ' hidden' : ''}`}>
                    <Dropdown
                        // overlay={this.renderMenu()} @deprecated
                        menu={{
                            items: this.getDropdownItems(),
                            className: "menu-company-dropdown",
                        }}
                        trigger={['click']}
                        onOpenChange={this.onMenuVisibleChange}
                    >
                        <div className="subdomain-container">
                            <div className="subdomain">
                                {subdomain}
                                &nbsp;
                            </div>
                            <DownOutlined />
                        </div>
                    </Dropdown>
                </div>
            </div>
        );
    };

    // reloadPage = () => {
    //     window.location.reload();
    // };

    // renderUpdateContent = (hideText = false) => (
    //     <div className="notice-box-container">
    //         <p className="logo">
    //             <ExclamationCircleOutlined className="exclaim" />
    //         </p>
    //         <p className={`text${hideText ? ' hidden' : ''}`}>
    //             <strong><Trans>Update Available</Trans></strong>
    //             <br />
    //             <Trans>Click to Update</Trans>
    //         </p>
    //     </div>
    // );

    onSearch = e => {
        const {
            companies,
        } = this.props;

        const {value} = e.target;
        if (!value) {
            return this.setState({
                filter: undefined,
            });
        }
        const filter = value.toUpperCase();

        const filteredCompanies = companies.filter(item => (
            item.legal_name?.toUpperCase()?.indexOf(filter) > -1 ||
            item.subdomain?.toUpperCase()?.indexOf(filter) > -1
        ));

        this.setState({
            filter,
            filteredCompanies,
        });
        return null;
    };

    /**
     * Label used for menu item.
     *
     * @param {*} item
     */
    getMenuItemLabel = item => (
        <Row wrap={false}>
            <Col className="legal-name" flex="auto">{ item.legal_name }</Col>
            <Col flex="none"><Tag>{ item.subdomain }</Tag></Col>
        </Row>
    );

    getDropdownItems = () => {
        const {
            companies,
            companyReadListState,
        } = this.props;
        const {
            filter,
            filteredCompanies,
        } = this.state;

        const companiesToShow = (filter) ? filteredCompanies : companies;

        const companiesItems =
            companyReadListState === 'request' ?
                [{
                    key: 'loading',
                    label: <Skeleton active title={false} size="small" />,
                }] :
                companiesToShow.map(item => {
                    const targetUrl = this.getUrl(item.subdomain);
                    return {
                        key: item.id,
                        className: 'item',
                        onClick: e => this.goToUrl(e, item.subdomain),
                        label: <a href={targetUrl}>{this.getMenuItemLabel(item)}</a>,
                    };
                });

        const items = [
            {
                key: 'search',
                className: 'company-search',
                label: (
                    <div
                        className="content"
                        onClick={e => {
                            e.stopPropagation();
                            this.inputRef.current?.focus();
                        }}
                    >
                        <Input.Search
                            className="input-search-companies"
                            placeholder={t`Search companies`}
                            onChange={this.onSearch}
                            onClick={e => e.stopPropagation()}
                            ref={this.inputRef}
                        />
                    </div>
                ),
            },
            {
                key: 'divider-1',
                className: 'divider-container',
                type: 'divider', // Must have
            },
            companiesItems.length ? {
                key: 'companies',
                type: 'group', // Must have
                className: 'company-dropdown-scrollable',
                children: companiesItems,
            } : null,
            companiesItems.length ? {
                key: 'divider-2',
                className: 'divider-container',
                type: 'divider', // Must have
            } : null,
            {
                key: 'new',
                onClick: this.showModal,
                label: <span>New Company...</span>,
            },
        ];

        return items;
    };

    // renderMenu = () => {
    //     const items = this.getDropdownItems();
    //     return <Menu className="menu-company-dropdown" items={items} />;
    // };

    render() {
        const {
            modalVisible,
        } = this.state;
        const {
            // updateAvailable,
            collapsed,
        } = this.props;

        return (
            <Styled>
                <ModalCompanyNew
                    visible={modalVisible}
                    onCancel={this.hideModal}
                />
                <div className="isoLogoWrapper company">
                    { this.renderLogoContent(collapsed) }
                </div>
                {/* { updateAvailable ?
                    <div
                        className="isoLogoWrapper notice-box update"
                        style={{ cursor: 'pointer'}}
                        onClick={() => ((!collapsed) ? this.reloadPage() : null)}
                    >
                        { this.renderUpdateContent(collapsed) }
                    </div> : null} */}
                {/* <SessionTimeoutTimer hideText={collapsed} /> */}
            </Styled>
        );
    }
}

export default connect(state => ({
    companies: state.Company.companies,
    companyReadListState: state.Company.companyReadListState,
    subdomain: state.Auth.subdomain,
    // updateAvailable: state.App.updateAvailable,
}), {
    readCompanies,
})(Logo);
